import { cachedRouteParams } from '../App';

export const TRACK_ROUTE_MISSING = 'TRACK_ROUTE_MISSING';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (mixpanel) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    mixpanel?.init('403597e23b9ee10a4db7f2fc6e59f3b7', { debug: false, ignore_dnt: true });
} else {
    console.warn('Mixpanel not loaded');
}

export const track = (name: string, params?: { [k: string]: string | undefined }): void => {
    const data = JSON.stringify({
        event: name,
        properties: params ? { ...cachedRouteParams, ...params } : cachedRouteParams,
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    window?.webkit?.messageHandlers?.mixPanel?.postMessage?.(data);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore

    window?.Eka?.sendEvent?.(data);

    if (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        !window?.Eka &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        !window?.webkit?.messageHandlers?.mixPanel?.postMessage &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel
    ) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        mixpanel?.track(name, params ? { ...cachedRouteParams, ...params } : cachedRouteParams);
    } else {
        console.error('Mixpanel not loaded');
    }
};
